module.exports = __webpack_public_path__ + "img/img.6edea266.png";